<div class="banner-inicio">
  <app-banner></app-banner>
</div>
<div class="noticia-inicio">
<app-noticia></app-noticia>
</div>

<!-- <app-carousel></app-carousel> -->
<app-card></app-card>
<app-card-moradores></app-card-moradores>
<app-agenda></app-agenda>